import t, { css, useTheme, ThemeProvider, createGlobalStyle } from 'styled-components';

var r=t,h=css,T=useTheme,n=ThemeProvider,c=(...e)=>createGlobalStyle(...e);

export { r as a, h as b, T as c, n as d, c as e };
